import { ORIGINAL_ACTION_TICK_MS } from '../shared/attack-timing';

export const ORIGINAL_WALK_STEP = 3;

/** Source SelfPlayerWalkAction moves 3 px on each 25 fps Map update. */
export function walkCadence(previousTick: number, now: number) {
  const ticks = Math.floor(Math.max(0, now - previousTick) / ORIGINAL_ACTION_TICK_MS);
  if (!ticks) return { distance: 0, tick: previousTick };
  // Drop a long suspended-tab backlog instead of jumping across the map.
  return { distance: Math.min(3, ticks) * ORIGINAL_WALK_STEP,
    tick: previousTick + ticks * ORIGINAL_ACTION_TICK_MS };
}
